export default function EventInfo() {
  const eventDetails = [
    {
      icon: 'ri-calendar-event-fill',
      label: 'Data e Horário',
      value: '11/03',
      extra: '19h30',
    },
    {
      icon: 'ri-map-pin-2-fill',
      label: 'Local',
      value: 'Atlas Hotel',
      extra: 'Barra do Bugres - MT',
    },
    {
      icon: 'ri-group-fill',
      label: 'Formato',
      value: 'Presencial',
      extra: '',
    },
    {
      icon: 'ri-alarm-warning-fill',
      label: 'Vagas',
      value: 'Limitadas',
      extra: 'Por horário',
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-3 px-4">
            <a href="#evento">
              Informações do{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
                Evento
              </span>
            </a>
          </h4>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mb-8">
          {eventDetails.map((detail) => (
            <div
              key={detail.label}
              className="bg-white rounded-2xl p-5 sm:p-7 shadow-md text-center border border-gray-100 hover:border-yellow-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className={`${detail.icon} text-xl sm:text-2xl text-black`}></i>
              </div>
              <p className="text-xs sm:text-sm font-bold text-gray-500 mb-1">{detail.label}</p>
              <p className="text-lg sm:text-xl font-black text-black">{detail.value}</p>
              {detail.extra && <p className="text-base sm:text-lg font-bold text-yellow-600">{detail.extra}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}